import carsTypes from "./cars.types";
import {addItemToHoldOver, removeItemFromHoldOver} from "./cars.utils";

const INITIAL_STATE = {
    carsData : [],
    selectedSingleCar: null,
    selectedCarInfo: null,
    reports: [],
    day: 0,
    option: false,
    Icon: '',
    ArrowIcon:'',
    playPause: false,
    interval: 0,
    reportIndex: 0,
    reportSpeed: 200,
    startRepTime:'',
    endRepTime:'',
    allDeviceInfo: [],
    holdoverCars: [],
    isWithOutPoint: false
};

const carsReducer = (state = INITIAL_STATE , action) => {
    switch (action.type){
        case carsTypes.GET_CARS_DATA :
            return{
                ...state,
                carsData: action.payload
            };
        case carsTypes.REMOVE_CARS_DATA :
            return{
                ...state,
                carsData: []
            };
        case carsTypes.CAR_SELECTED :
            return{
                ...state,
                selectedCarInfo: action.payload
            };
        case carsTypes.REMOVE_CAR_SELECTED_INFO :
            return{
                ...state,
                selectedCarInfo: null
            };
        case carsTypes.GET_REPORTS :
            return{
                ...state,
                reports: action.payload
            };
        case carsTypes.CHANGE_DAY :
            return{
                ...state,
                day: action.payload
            };
        case carsTypes.GET_SINGLE_CAR_DATA :
            return{
                ...state,
                selectedSingleCar: action.payload
            };
        case carsTypes.SET_ICONS :
            return{
                ...state,
                Icon: action.payload
            };
        case carsTypes.PLAY_PAUSE :
            return{
                ...state,
                playPause: !state.playPause
            };
        case carsTypes.SET_INTERVAL :
            return{
                ...state,
                interval: action.payload
            };
        case carsTypes.SET_REPORT_INDEX :
            return{
                ...state,
                reportIndex: action.payload
            };
        case carsTypes.SET_REPORT_SPEED :
            return{
                ...state,
                reportSpeed: action.payload
            };
        case carsTypes.SET_ARROW_ICON :
            return{
                ...state,
                ArrowIcon: action.payload
            };
        case carsTypes.SET_START_REP_TIME :
            return{
                ...state,
                startRepTime: action.payload
            };
        case carsTypes.SET_END_REP_TIME :
            return{
                ...state,
                endRepTime: action.payload
            };
        case carsTypes.ADD_HOLDOVER_CAR :
            return{
                ...state,
                holdoverCars: addItemToHoldOver(state.holdoverCars, action.payload)
            };
        case carsTypes.REMOVE_HOLDOVER_CAR :
            return{
                ...state,
                holdoverCars: removeItemFromHoldOver(state.holdoverCars, action.payload)
            };
        case carsTypes.CLEAR_HOLDOVER_CARS :
            return{
                ...state,
                holdoverCars: []
            };
        case carsTypes.SET_HOLDOVER_CARS :
            return{
                ...state,
                holdoverCars: action.payload
            };
        case carsTypes.SET_ALL_DEVICE_INFO :
            return{
                ...state,
                allDeviceInfo: action.payload
            };
        case carsTypes.SET_IS_WITH_OUT_POINT :
            return{
                ...state,
                isWithOutPoint: action.payload
            };
        default:
            return state
    }
};

export default carsReducer